import { FC } from "react";
import { useCancelMeeting } from "@/api/routes/account/mutations";
import { toast } from "react-hot-toast";
import { ConfirmActionModal } from "shared/ui/modal/confirm-action";

import { swallow } from "@/api/legacy-swallow";

interface AccountCancelMeetingConfirmationModalPropsI {
  // Two instances live on the account drawer (status menu and calendar-event
  // card); a shared id would open both from one click.
  modalId?: string;
  campaignId?: string;
  accountId?: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export const CONFIRM_CANCEL_MEETING_MODAL_ID = "confirm-cancel-meeting-modal";

export const AccountCancelMeetingConfirmationModal: FC<
  AccountCancelMeetingConfirmationModalPropsI
> = ({
  modalId = CONFIRM_CANCEL_MEETING_MODAL_ID,
  campaignId,
  accountId,
  onSuccess = () => {},
  onCancel = () => {},
}) => {
  const { mutateAsync: cancelMeeting } = useCancelMeeting();

  const handleCancelMeeting = () => {
    if (!campaignId || !accountId) {
      return toast.error("Campaign ID and Account ID are required");
    }

    return swallow(
      cancelMeeting(
        { campaignId, accountId },
        {
          onSuccess: () => {
            toast.success("Meeting has been canceled successfully");
            onSuccess();
          },
          onError: () =>
            toast.error(
              "Failed to cancel meeting. Please message us in the chat window on the bottom right so we can assist."
            ),
        }
      )
    );
  };

  return (
    <ConfirmActionModal
      id={modalId}
      title="Cancel meeting"
      description="Are you sure you want to cancel this meeting?"
      onConfirm={handleCancelMeeting}
      onCancel={onCancel}
    />
  );
};
